<section class="tickets-page">
  <header class="tickets-page-header">
    <h1>Tickets de défauts</h1>

    <div class="tickets-page-actions">
      <div class="tickets-filtre-bar">
        <span class="material-symbols-outlined tickets-filtre-icon" aria-hidden="true">search</span>
        <input
          #recherche
          class="tickets-filtre-input"
          type="search"
          placeholder="Rechercher un ticket..."
          aria-label="Rechercher un ticket"
          [value]="etat.filtreTexteTickets()"
          (input)="etat.filtreTexteTickets.set(recherche.value)"
        />
        @if (etat.filtreTexteTickets()) {
          <button
            type="button"
            class="tickets-filtre-clear"
            aria-label="Effacer la recherche"
            (click)="etat.filtreTexteTickets.set('')"
          >
            <span class="material-symbols-outlined" aria-hidden="true">close</span>
          </button>
        }
      </div>
      <button
        type="button"
        class="tickets-action"
        [class.tickets-action-active]="filtresActifs().length > 0"
        cdkOverlayOrigin
        #origineFiltres="cdkOverlayOrigin"
        aria-haspopup="dialog"
        [attr.aria-expanded]="panneauFiltresOuvert()"
        (click)="ouvrirFiltres()"
      >
        <span class="material-symbols-outlined" aria-hidden="true">filter_list</span>
        <span>Filtrer{{ filtresActifs().length ? ' (' + filtresActifs().length + ')' : '' }}</span>
      </button>
      <button type="button" class="tickets-action" [matMenuTriggerFor]="menuTri">
        <span class="material-symbols-outlined" aria-hidden="true">swap_vert</span>
        <span>Trier : {{ triActif() === 'date' ? 'date' : 'libellé' }}</span>
      </button>
    </div>
  </header>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origineFiltres"
    [cdkConnectedOverlayOpen]="panneauFiltresOuvert()"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayViewportMargin]="12"
    [cdkConnectedOverlayPush]="true"
    (backdropClick)="panneauFiltresOuvert.set(false)"
    (overlayKeydown)="$event.key === 'Escape' && panneauFiltresOuvert.set(false)"
  >
    <section
      class="tickets-filtres-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="titre-filtres-tickets"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
    >
      <header class="tickets-filtres-header">
        <div>
          <h2 id="titre-filtres-tickets">Filtrer les tickets</h2>
          <p>Affinez les résultats dans tous les silos.</p>
        </div>
        <button
          type="button"
          class="tickets-filtres-close"
          aria-label="Fermer sans appliquer"
          (click)="panneauFiltresOuvert.set(false)"
        >
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button>
      </header>
      <div class="tickets-filtres-body">
        @for (groupe of groupesFiltres; track groupe.titre) {
          <fieldset class="tickets-filtres-group">
            <legend>{{ groupe.titre }}</legend>
            <p>{{ groupe.aide }}</p>
            @for (filtre of groupe.filtres; track filtre.valeur) {
              <label
                class="tickets-filtres-option"
                [class.selected]="brouillonFiltres().includes(filtre.valeur)"
              >
                <input
                  type="checkbox"
                  [checked]="brouillonFiltres().includes(filtre.valeur)"
                  (change)="basculerBrouillonFiltre(filtre.valeur)"
                />
                <span>{{ filtre.libelle }}</span>
              </label>
            }
          </fieldset>
        }
      </div>
      <footer class="tickets-filtres-footer">
        <div class="tickets-filtres-summary">
          <span aria-live="polite"
            >{{ brouillonFiltres().length }} sélectionné{{
              brouillonFiltres().length > 1 ? 's' : ''
            }}</span
          >
          <button
            type="button"
            class="tickets-filtres-reset"
            [disabled]="!brouillonFiltres().length"
            (click)="brouillonFiltres.set([])"
          >
            Tout effacer
          </button>
        </div>
        <div class="tickets-filtres-buttons">
          <button
            type="button"
            class="tickets-filtres-cancel"
            (click)="panneauFiltresOuvert.set(false)"
          >
            Annuler
          </button>
          <button type="button" class="tickets-filtres-apply" (click)="appliquerFiltres()">
            Appliquer les filtres
          </button>
        </div>
      </footer>
    </section>
  </ng-template>
  <mat-menu #menuTri="matMenu" aria-label="Options de tri">
    @for (tri of trisDisponibles; track tri.valeur) {
      <button
        mat-menu-item
        role="menuitemradio"
        [attr.aria-checked]="triActif() === tri.valeur"
        (click)="triActif.set(tri.valeur)"
      >
        <span class="material-symbols-outlined tickets-option-icon" aria-hidden="true">{{
          triActif() === tri.valeur ? 'radio_button_checked' : 'radio_button_unchecked'
        }}</span>
        {{ tri.libelle }}
      </button>
    }
  </mat-menu>

  @if (filtresActifs().length) {
    <div class="tickets-filtres-actifs" aria-label="Filtres actifs">
      @for (filtre of libellesFiltresActifs(); track filtre.valeur) {
        <button
          type="button"
          class="tickets-filtre-actif"
          [attr.aria-label]="'Retirer le filtre ' + filtre.libelle"
          (click)="basculerFiltre(filtre.valeur)"
        >
          {{ filtre.libelle }}
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button>
      }
    </div>
  }

  <div class="tickets-layout" [class.avec-agenda]="!routeInstallationId()">
    <div
      class="tickets-board"
      [class.tickets-board-loading]="chargement()"
      [attr.aria-busy]="chargement()"
    >
      <app-spinner-overlay [visible]="chargement()" label="Chargement des tickets…" />
      @for (silo of silos(); track trackBySilo($index, silo)) {
        <app-silo-tickets
          [title]="silo.title"
          [count]="silo.count"
          [badgeCount]="silo.badgeCount"
          [state]="silo.state"
          [tickets]="silo.tickets"
          [showSiteName]="!routeInstallationId()"
          [hasMore]="silo.currentPage < silo.totalPages"
          [loadingMore]="silo.loadingMore"
          [erreur]="silo.erreur ?? ''"
          (reessayer)="reessayerChargement(silo.state)"
          [dragActive]="!!drag.draggingTicket()"
          [itemsDraggable]="
            silo.state === 'nouveau' || silo.state === 'encours' || silo.state === 'enattente'
          "
          [canDrop]="drag.peutRecevoirDrop(silo.state)"
          [isDropTarget]="drag.dropTargetState() === silo.state"
          [isDisabledTarget]="
            !!drag.draggingTicket() &&
            !drag.peutRecevoirDrop(silo.state) &&
            drag.invalidDropTargetState() !== silo.state
          "
          [isInvalidTarget]="drag.invalidDropTargetState() === silo.state"
          [invalidMessage]="'Déplacement non autorisé'"
          (loadMore)="chargerPageSuivante(silo.state)"
          (ticketDragStarted)="onTicketDragStarted(silo.state, $event)"
          (ticketDragEnded)="onTicketDragEnded()"
          (siloDragEntered)="onSiloDragEntered(silo.state)"
          (siloDragLeft)="onSiloDragLeft(silo.state)"
          (siloDropped)="onSiloDropped(silo.state)"
          (siloInvalidDropped)="onSiloInvalidDropped(silo.state)"
          (ticketClicked)="onTicketClicked(silo.state, $event)"
        />
      }
    </div>

    @if (!routeInstallationId()) {
      <app-prochaines-interventions />
    }
  </div>

  @if (drag.toastMessage()) {
    <div class="tickets-toast" role="status" aria-live="polite">
      {{ drag.toastMessage() }}
    </div>
  }
</section>
